 import axiosInstance from './../interceptor/interceptor';
import CryptoJS from 'crypto-js';
const SECRET_KEY = 'thequickdonckeyjumpsoverthelazydog'; 

const react_app_base_url = process.env.REACT_APP_API_BASE_URL;

export const userService = {
  loginUser,
  fetchSettings,
  encryptData,
  decryptData,
//   getMonthlyBudget,
  //   updateCourse,
};

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};
// , "Authorization": `bearer ${localStorage.getItem('ed_token')}`

function loginUser(obj) {
  return axiosInstance.post(`api?method=social_login`,obj);
}

function fetchSettings(obj){
  
  return axiosInstance.get(`api?method=fetch_settings&user_id=${encodeURIComponent(obj.user_id)}`);
  // .then((resp) => {
  //   if (resp.data.status === 200) {
  //     return resp.data.result;
  //   } else {
  //     return resp.data;
  //   }
  // }).catch(err=>{
  //   return err;
  // })

}



var CryptoJSAesJson = {
  stringify: function (cipherParams) {
      var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
      if (cipherParams.iv) j.iv = cipherParams.iv.toString();
      if (cipherParams.salt) j.s = cipherParams.salt.toString();
      return JSON.stringify(j);
  },
  parse: function (jsonStr) {
      var j = JSON.parse(jsonStr);
      var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams;
  }
}

function encryptData(data,enType){
  if(enType == "base64"){
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
  } else {
    return CryptoJS.AES.encrypt(data.toString(), SECRET_KEY, {format: CryptoJSAesJson}).toString();
  }
}


function decryptData(data, enType){
  
  if(enType == "base64"){
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  } else {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);  
    return originalText;
  }
}
